export default __webpack_public_path__ + "static/media/accessdenied.340d3b1d.png";